// extracted by css-extract-rspack-plugin
export default {"iconContainer":"_3b5893e4"};